// 3rd-party modules
import { isMobile } from "react-device-detect";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// project modules
import AccountKiboshDeviceMenuModal from "../../components/accounts/kibosh-device/AccountKiboshDeviceMenuModal";
import AccountKiboshDeviceModal from "../../components/accounts/kibosh-device/AccountKiboshDeviceModal";
import Loader from "../../components/shared/loader";
import { Account } from "../../models/account";
import { apiCall } from "../../helpers/apiHelper";
import { RootState } from "../../stores";

// apis
import * as AuthApi from "../../apis/authApi"

// models
import { AccountKiboshDevice } from "../../models/accountKiboshDevice";

export default function DnsPage() {
  const kiboshDevice = useSelector((state: RootState) => state.user.kiboshDevice) || new AccountKiboshDevice();

  const [currentAccount, setCurrentAccount] = useState<Account>(new Account());
  const [currentAccountKiboshDevice, setCurrentAccountKiboshDevice] =
    useState<AccountKiboshDevice>(kiboshDevice);
  const [loading, setLoading] = useState<boolean>(false);
  const [showAccountKiboshDeviceMenuModal, setShowAccountKiboshDeviceMenuModal] = useState(true);

  const navigate = useNavigate();
  let abortController = new AbortController();

  useEffect(() => {
    let abortController = new AbortController();

    getAccountAsync();

    return () => { abortController.abort(); }
  }, []);

  useEffect(()=> {
    if (!showAccountKiboshDeviceMenuModal) {
      navigate(-1);
    }
  },[showAccountKiboshDeviceMenuModal]);

  const getAccountAsync = async () => {
    const account = await getAccount(abortController.signal);

    if (account) {
      setCurrentAccount(account!);
    }
  }

  const getAccount = async (abortSignal?: AbortSignal) => {
    setLoading(true);
    const response = await apiCall(AuthApi.getAccount(abortSignal));
    setLoading(false);

    return response.success ? Account.toClass(response.data?.value) : null;
  };

  const onAccountKiboshDeviceSave = (e?: AccountKiboshDevice) => {
    if (e) {
      setLoading(true);
      setCurrentAccountKiboshDevice(e);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loader/>}
      {
        isMobile ?
          <AccountKiboshDeviceMenuModal
            open={showAccountKiboshDeviceMenuModal}
            closeOnSave={true}
            account={currentAccount!}
            accountKiboshDevice={kiboshDevice}
            onClose={() => setShowAccountKiboshDeviceMenuModal(false)}
          />
        :
          <AccountKiboshDeviceModal
            modalTitle={
                `${
                  !currentAccountKiboshDevice.accountKiboshDeviceId
                    ? "New Kibosh Device"
                    : `Kibosh Device Name: ${currentAccountKiboshDevice.kiboshDeviceName}`
                }`
            }
            open={showAccountKiboshDeviceMenuModal}
            closeOnSave={true}
            account={currentAccount!}
            isModal={false}
            accountKiboshDevice={currentAccountKiboshDevice}
            onClose={() => setShowAccountKiboshDeviceMenuModal(false)}
            onSave={(e) => onAccountKiboshDeviceSave(e)}
          />
      }
    </>
  );
}
